import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
import { LazyImage } from '@/components/common';
import { caculateTapStatus } from '../utils';
// import ChaoTag from './ChaoTag.vue'
import LicenseInfo from './LicenseInfo.vue';

// 头部基础信息，演出名、演出海报、独家 || 总代标签、价格、榜单、票区图
export default {
  name: 'basic-info',
  components: {
    LazyImage: LazyImage,
    // ChaoTag
    LicenseInfo: LicenseInfo
  },
  props: {
    performanceInfo: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      nameMore: false,
      openName: false,
      defaultNameClass: ''
    };
  },
  computed: {
    smallTag: function smallTag() {
      var performanceInfo = this.performanceInfo;
      return performanceInfo.sellPriceList && performanceInfo.sellPriceList[1] && performanceInfo.sellPriceList[0].length + performanceInfo.sellPriceList[1].length > 7;
    },
    detailActivityTagUrl: function detailActivityTagUrl() {
      var performanceInfo = this.performanceInfo;
      if (!performanceInfo) return '';
      var couponActivityTagVO = performanceInfo.couponActivityTagVO,
        promotional = performanceInfo.promotional,
        detailActivityTagUrl = performanceInfo.detailActivityTagUrl;

      // 活动标签>早鸟票， 售中优惠需求新增的逻辑：https://wiki.maoyan.com/pages/viewpage.action?pageId=247635178
      if (couponActivityTagVO && couponActivityTagVO.detailActivityTagUrl || detailActivityTagUrl) {
        return detailActivityTagUrl || couponActivityTagVO && couponActivityTagVO.detailActivityTagUrl;
      }

      // 含有早鸟票优惠
      if (promotional && promotional.promotionDetails && promotional.promotionDetails.some(function (item) {
        return item.type === 1;
      })) {
        // 项目详情页面的早鸟活动icon
        return 'https://p0.pipi.cn/rock/prod/common/image/5130b368a27d0b1257dd84f4f734df49.png?imageMogr2/thumbnail/2500x2500%3E';
      }
      return '';
    },
    // 头部标签类型
    tagType: function tagType() {
      return caculateTapStatus(this.performanceInfo);
    },
    showGeneralAgentIcon: function showGeneralAgentIcon() {
      return this.tagType === 'generalAgent';
    },
    showExclusiveAgentIcon: function showExclusiveAgentIcon() {
      return ['exclusive', 'exclusive-agent'].includes(this.tagType);
    },
    // 头部标签 宽度
    tagWidth: function tagWidth() {
      // 15 为间隙
      if (this.tagType === 'generalAgent') {
        return 65 + 15;
      } else if (this.tagType === 'exclusive') {
        return 53 + 15;
      } else if (this.tagType === 'exclusive-agent') {
        return 53;
      } else {
        return 0;
      }
    },
    // 折后价 和 榜单入口 同时存在时，name最多展示两行，其余时候最多展示三行
    nameMax2Line: function nameMax2Line() {
      // 折后价 和 榜单入口 同时存在时，name最多两行
      return !!(this.performanceInfo.billBoardVO && this.performanceInfo.discountPriceStr);
    },
    nameClass: function nameClass() {
      if (this.defaultNameClass) return this.defaultNameClass;
      if (!this.nameMore) return '';
      return this.nameMax2Line ? 'line-2' : 'line-3';
    },
    // 价格范围， 新版样式一行布局超出换二行、旧版直接二行布局
    priceWarpFlex: function priceWarpFlex() {
      var performanceInfo = this.performanceInfo;
      if (performanceInfo.seatUrl) {
        return performanceInfo.discountPriceStr && performanceInfo.discountPriceStr.length < 12;
      } else {
        return performanceInfo.discountPriceStr && performanceInfo.discountPriceStr.length < 20;
      }
    },
    discountPriceHtml: function discountPriceHtml() {
      try {
        if (this.performanceInfo.discountPriceStr.includes('折后')) {
          return '';
        }
        if (this.performanceInfo.discountPriceStr.includes('张 | ')) {
          return '<span style="margin-right: 2px;font-weight: bold">套票</span>' + this.performanceInfo.discountPriceStr.split(' | ')[1].split('元')[0] + '<span style="margin-left: 2px">元<span style="margin:0 2px">/</span>张</span>';
        }
        if (!this.performanceInfo || !this.performanceInfo.discountPriceStr) return '';
        return this.performanceInfo.discountPriceStr.split('/').map(function (str) {
          return str.trim();
        }).join('<span style="padding: 0 2px">/</span>').split('|').map(function (str) {
          return str.trim();
        }).join('<span style="padding: 0 3px 0 2px">|</span>');
      } catch (error) {
        return null;
      }
    },
    // 是否展示证照信息icon
    hasPublicLicense: function hasPublicLicense() {
      var sellChannel = Drip.constant.appType;
      //  美大猫微M站+抖音小程序+小红书
      return this.performanceInfo.publicityStatus && [1, 2, 3, 5, 7, 8, 13, 29, 30, 31].includes(sellChannel);
    }
  },
  mounted: function mounted() {
    this.discountViewStats();
    this.initNameStr();
  },
  methods: {
    initNameStr: function initNameStr() {
      var _this = this;
      this.defaultNameClass = 'line-none';
      setTimeout(function () {
        _this.defaultNameClass = '';
        var nameWrapper = _this.$refs.nameWrapper;
        var height = nameWrapper.clientHeight;
        _this.nameMore = height > (_this.nameMax2Line ? 54 : 76);
        if (!_this.nameMore) {
          _this.$nextTick(function () {
            _this.defaultNameClass = 'line-3';
          });
        }
      }, 100);
    },
    openAllName: function openAllName() {
      if (!this.nameMore) return;
      this.openName = !this.openName;
    },
    seatPreview: function seatPreview() {
      this.$emit('seatPreview');
    },
    openCouponModal: function openCouponModal() {
      // 抖音演出小程序不展示折扣优惠信息，避免审核项目被抖音驳回
      if (Drip.UA.IS_DouyinShowMicroApp) {
        return;
      }
      this.$emit('togglePromotion');
      window.lxTagReport('c_c21utqjf', 'b_movie_rmdy3t3g_mc');
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_rmdy3t3g_mc'
      });
    },
    gotoTop: function gotoTop(id, attr) {
      window.lxTagReport('c_c21utqjf', 'b_movie_7973vwvx_mc', {
        performance_id: this.performanceInfo.performanceId
      });
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_7973vwvx_mc',
        cid: 'c_c21utqjf',
        custom: {
          performance_id: this.performanceInfo.performanceId
        }
      });
      var city = this.performanceInfo.cityId || 0;
      this.go("/top/".concat(id, "?type=2&attr=").concat(attr, "&city=").concat(city), {
        _blank: true
      });
    },
    discountViewStats: function discountViewStats() {
      if (this.performanceInfo.discountPriceStr) {
        window.seedAction({
          evt: 'view',
          bid: 'b_movie_rmdy3t3g_mv'
        });
      }
    }
  }
};